import { IObjectReferableFeature } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectBean, IXElementContentsObjectRelationalBean } from "../../../beans";
import { RelationTranslator } from "./RelationTranslator";
import { ILinkedObjectTranslatable } from "./ILinkedObjectTranslatable";

export class ObjectReferableFeatureTranslator<T> {
  constructor(action: string, private readonly reference: ILinkedObjectTranslatable<T>) {
    this.relationalItems = new RelationTranslator(action);
  }

  from(bean: IXElementContentsObjectBean): IObjectReferableFeature<T> {
    return this.relationalItems.from(
      bean,
      is => ({
        isEnable: (0 < is.length),
        reference: this.reference.from(is[0]),
      }),
      {
        isEnable: false,
        reference: null,
      });
  }

  to(object: IObjectReferableFeature<T>): IXElementContentsObjectRelationalBean {
    return object.isEnable
      ? this.relationalItems.to([
        this.reference.to(object.reference),
      ])
      : undefined;
  }

  private readonly relationalItems: RelationTranslator;
}
